module.exports = __webpack_public_path__ + "img/fluidBall_poster.7ab6c2bb.jpg";